import { i18n } from '@/_plugins/i18n';
import { csvExport } from "@/_helpers";

export function createCsvInvoice(
        isReading,
        fileName,
        projectName,
        presetName,
        currentUser,
        dateFrom,
        dateTo,
        table,
        total,
		localISOTime,
		delimeter
        )
{
    var csv = csvTemplate;
    csv = resolveTotalSum(csv, isReading, delimeter);
    csv = fillTheLocale(csv, isReading, delimeter);
    // Fill the customer
    csv = csv.replaceAll("{{PROJECT_NAME}}", projectName);
    csv = csv.replaceAll("{{PRESET_NAME}}", presetName);
    csv = csv.replaceAll("{{USER_NAME}}", currentUser);
    csv = csv.replaceAll("{{DATE_GENERATED}}", localISOTime);
    // Fill From-To date to invoice
    csv = csv.replaceAll("{{DATE_FROM}}", dateFrom);
    csv = csv.replaceAll("{{DATE_TO}}", dateTo);
    // Fill content table
    csv = fillInvocieContent(table, csv, delimeter);
    // Fill total calculations
    if (!isReading) {
        csv = csv.replaceAll("{{TOTAL}}", total);
    }

    csvExport(csv, fileName);
}

function resolveTotalSum(csv, isReading, delimeter) {
    let totalCsv = `${delimeter}${delimeter}${delimeter}${delimeter}${delimeter}{{LOCALE_TOTAL}}: {{TOTAL}}`
    return csv.replaceAll("{{CONTENT_TOTAL}}", isReading ? "" : totalCsv);
}

function fillTheLocale(csv, isReading, delimeter) {
    csv = csv.replaceAll("{{DELIMETER}}", delimeter);
	csv = csv.replaceAll("{{LOCALE_PROJECT}}", i18n.t("project.graphViewer.reports.projectName"));
    csv = csv.replaceAll("{{LOCALE_PRESET}}", i18n.t("project.graphViewer.reports.presetName"));
    csv = csv.replaceAll("{{LOCALE_USER}}", i18n.t("project.graphViewer.reports.userName"));
    csv = csv.replaceAll("{{LOCALE_DATE_GEN}}", i18n.t("project.graphViewer.reports.dateGen"));
    csv = csv.replaceAll("{{LOCALE_ID}}", i18n.t("project.graphViewer.reports.id"));
  csv = csv.replaceAll("{{LOCALE_UNIT}}", i18n.t("project.graphViewer.reports.unit"));
	csv = csv.replaceAll("{{LOCALE_DESC}}", i18n.t("project.graphViewer.reports.description"));
	csv = csv.replaceAll("{{LOCALE_FOOTER}}", i18n.t("project.graphViewer.reports.footer"));

    csv = csv.replaceAll("{{LOCALE_DATE_FROM}}",
        isReading ? i18n.t("project.graphViewer.reports.reading.date") : i18n.t("project.graphViewer.reports.consumption.dateFrom"));
    csv = csv.replaceAll("{{LOCALE_DATE_TO}}", isReading ? "" : `${i18n.t("project.graphViewer.reports.consumption.dateTo")}:`);
    csv = csv.replaceAll("{{LOCALE_START_VAL}}", isReading ? "" : i18n.t("project.graphViewer.reports.consumption.startValue"));
    csv = csv.replaceAll("{{LOCALE_END_VAL}}", isReading ? "" : i18n.t("project.graphViewer.reports.consumption.endValue"));
    csv = csv.replaceAll("{{LOCALE_SUM_VAL}}",
        isReading ? i18n.t("project.graphViewer.reports.reading.value") : i18n.t("project.graphViewer.reports.consumption.sumValue"));

    if (!isReading) {
        csv = csv.replaceAll("{{LOCALE_TOTAL}}", i18n.t("project.graphViewer.reports.consumption.totalSum"));
    }

    return csv;
}

function fillInvocieContent(table, csv, delimeter) {
    let content = "";
    for (let i = 0; i < table.length; i++) {
        content += `${table[i][1]}${delimeter}${table[i][0]}${delimeter}${table[i][5]}${delimeter}${table[i][2]}${delimeter}${table[i][3]}${delimeter}${table[i][4]}\n`
    }
    return csv.replaceAll("{{CONTENT}}", content);
}

var csvTemplate =
`
Tronic Control s.r.o.
info@tronic.cz
www.tronic.cz

{{LOCALE_PROJECT}}: {{PROJECT_NAME}}
{{LOCALE_PRESET}}: {{PRESET_NAME}}
{{LOCALE_USER}}: {{USER_NAME}}
{{LOCALE_DATE_GEN}}: {{DATE_GENERATED}}

{{LOCALE_DATE_FROM}}: {{DATE_FROM}}
{{LOCALE_DATE_TO}} {{DATE_TO}}

{{LOCALE_DESC}}{{DELIMETER}}{{LOCALE_ID}}{{DELIMETER}}{{LOCALE_UNIT}}{{DELIMETER}}{{LOCALE_START_VAL}}{{DELIMETER}}{{LOCALE_END_VAL}}{{DELIMETER}}{{LOCALE_SUM_VAL}}
{{CONTENT}}
{{CONTENT_TOTAL}}

{{LOCALE_FOOTER}}
`
